export const iconFontAwesomeClothingFashionMitten = (
	<i className="fa-solid fa-mitten"></i>
);
